"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (href) {
  return href;
};